import React from 'react';
import ReactCSSTransition from 'react-transition-group/CSSTransition';
import { Form, FormFeedback, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import ButtonAction from './ButtonAction';
import * as warnings from '../constants/ValidationWarnings';

export default class EntityForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formElements: this.props.formElements || {},
      valid: true,
      size: this.props.size || 'md',
      complete: true,
    };
  }

  validator(attr, input) {
    return this.props.validate ? this.props.validate(attr, input) : true;
  }

  handleValidation = (attribute, value) => {
    this.setState({ valid: this.validator(attribute, value) });
  }

  handleChange = (e) => {
    const newState = this.state.formElements;
    const name = e.target.name || e.currentTarget.name;
    const t = e.target.value;
    this.handleValidation(name, t);
    newState[name] = t.length === 0 ? null : t;
    this.setState({ formElements: newState });
  }

  handleSelectChange = (name, value) => {
    const newState = this.state.formElements;
    newState[name] = value;
    this.setState({ formElements: newState });
  }

  hasRequiredFields = () => {
    for (const field of this.props.fields) {
      if (!field.required || field.type === 'select') {
        continue;
      }
      if (!!this.state.formElements[field.name] && this.state.formElements[field.name] !== '') {
        continue;
      } else {
        return false;
      }
    }
    return true;
  }

  submitForm = (e) => {
    e.preventDefault();
    if (this.hasRequiredFields() && this.state.valid) {
      this.setState({ complete: true, formElements: {} });
      this.props.action(this.state.formElements);
    } else {
      this.setState({ complete: false });
    }
  }

  renderedField = (field) => {
    if (field.type === 'select') {
      return (<td key={field.name}>
        <Input
          name={field.name}
          onChange={e => this.handleSelectChange(field.name, e.target.value)}
          bsSize={this.state.size}
          defaultValue={this.state.formElements[field.name]}
          type="select"
        >
          {field.options.map((opt, index) => (<option key={`opt${index}`} value={opt.value}>
            {opt.label}
          </option>))}
        </Input>
      </td>);
    }
    return (<td key={field.name}>
      <Input
        id={field.name}
        name={field.name}
        onChange={this.handleChange}
        placeholder={field.text}
        required={field.required}
        bsSize={this.state.size}
        defaultValue={this.state.formElements[field.name]}
        type="text"
      />
      <Label for={field.name} hidden>{field.text}</Label>
    </td>);
  }

  render() {
    return (

        <tr className="row-cols-lg-auto g-3 align-items-center editable-group">
          {this.props.fields.map(field =>
              this.renderedField(field),
          )}
          <td>
            {this.props.deletable ?
              <ButtonAction
                type="clear"
                action={this.props.formButtonAction}
                size={this.state.size}
                color="warning"
                icon="fa-remove"
              /> : null
            }
            {this.props.noSubmit ? null :
              <ButtonAction
                type="submit"
                action={this.submitForm}
                size={this.state.size}
                icon="fa-check"
              />
            }
            <ReactCSSTransition
              classNames="fade"
              timeout={{ enter: 500, exit: 300 }}>
              {!this.state.valid || !this.state.complete ?
                <div className="feedback">
                  {this.props.warning ? this.props.warning : null}
                  {!this.state.complete ? warnings.INCOMPLETE : null}
                </div> : <div/>
              }
            </ReactCSSTransition>
          </td>
        </tr>

    );
  }
}
